import type { CountryCode } from 'libphonenumber-js'
import parseMobile, { getCountryCallingCode } from 'libphonenumber-js'

export interface PhoneNumberUtils {
  formatNational: (mobile: string) => string
  formatInternational: (mobile: string) => string
  parseMobile: (mobile?: string) => string
  parseToE164NumberWithoutPlusPrefix: (mobile?: string) => string
  formatIntMaskedNumber: (number: string | undefined) => string
}

export const createPhoneNumberUtils = (country?: CountryCode): PhoneNumberUtils => {
  const formatNational = (mobile: string = ''): string => {
    const phoneNumber = parseMobile(mobile, country)
    if (typeof phoneNumber === 'undefined') {
      return ''
    }
    return phoneNumber.formatNational()
  }

  const formatInternational = (mobile: string = ''): string => {
    const phoneNumber = parseMobile(mobile, country)
    if (typeof phoneNumber === 'undefined') {
      return ''
    }
    return phoneNumber.formatInternational()
  }

  const parse = (mobile: string = ''): string => {
    const phoneNumber = parseMobile(mobile, country)
    if (typeof phoneNumber === 'undefined') {
      return ''
    }
    return phoneNumber.isValid() && phoneNumber.country === country ? (phoneNumber.nationalNumber as string) : ''
  }

  const parseToE164NumberWithoutPlusPrefix = (mobile: string = ''): string => {
    const phoneNumber = parseMobile(mobile, country)
    if (typeof phoneNumber === 'undefined') {
      return ''
    }
    const e164NumberStr = phoneNumber.number as string
    const e164NumberWithoutPlusPrefix = e164NumberStr
      .split('')
      .filter((d) => d !== '+')
      .join('')

    return phoneNumber.isValid() && phoneNumber.country === country ? e164NumberWithoutPlusPrefix : ''
  }

  const formatIntMaskedNumber = (number?: string): string => {
    if (typeof number === 'undefined') {
      return ''
    }
    const last2 = number.slice(-2)
    const callingCode = getCountryCallingCode(country as CountryCode)
    return `+${callingCode} ••• ••• ${last2}`
  }

  return { formatNational, formatInternational, parseMobile: parse, parseToE164NumberWithoutPlusPrefix, formatIntMaskedNumber }
}
